/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('FdtCtrl', function(
    $scope,
    Activity,
    Log,
    currentModules,
    ngNotify,
    momentPicker,
    FormElementService,
    identity
) {
    const me                         = identity;
    $scope.current_modules     = currentModules.filter(function(module) {
        const DAY_IN_MILLISECONDS = 1000 * 60 * 60  * 24;
        const date_start = new Date(module.date_start);
        const date_end = new Date(module.date_end);
        const now = new Date();
        const days_since_ended = Math.round((now.getTime() - date_end.getTime()) / DAY_IN_MILLISECONDS);
        const not_yet_started = moment(now).isBefore(moment(date_start));
        if ((days_since_ended >= 30) || not_yet_started) {
            return false;
        }
        const matches = module.uv_name.match(/(^SPE-((?!CLO\d|ING\d|DEV\d))|^ETN-|-GPEA$)/);
        if (matches != null) {
            return false;
        }
        return true;
    });

    $scope.loading             = false;
    $scope.start_pickr         = momentPicker;
    $scope.end_pickr           = momentPicker;
    $scope.errors              = FormElementService.getErrors(true);
    $scope.min_date            = moment().startOf('day');
    $scope.max_date            = moment().endOf('day');
    $scope.content             = {
        goals: '',
        actions: '',
        results: '',
        difficulties: ''
    };
    $scope.sos_jawa            =
        {value: false};
    $scope.schedules           = [];

    const fetchSchedules = () => Log
		  .getSchedulesCurrentRun({
			  login: me.login
		  })
		  .$promise
		  .then(function(data) {
			  // Default declaration allowance: today + yesterday
			  let schedule;
			  $scope.schedules = [ {
				  name: "Aujourd'hui",
				  start: moment().startOf('day'),
				  end: moment().endOf('day')
			  }, {
				  name: 'Hier',
				  start: moment().subtract(1, 'days').startOf('day'),
				  end: moment().subtract(1, 'days').endOf('day')
			  } ];
			  // Add planned schedules for current run
			  const events = [];
			  for (let contract of Array.from(data.contracts)) {
				  var run_schedules = contract != null ? contract.schedules : undefined;
				  if ((run_schedules != null) && (run_schedules !== [])) {
					  run_schedules = ((() => {
						  const result = [];
						  for (schedule of Array.from(run_schedules)) {
							  result.push({
								  name: `Créneau prévu ${moment(schedule.start).format('DD-MM-YYYY HH:mm')} → ` +
									  `${moment(schedule.end).format('DD-MM-YYYY HH:mm')}`,
								  start: moment(schedule.start),
								  end: moment(schedule.end),
							  });
						  }
						  return result;
					  })());
					  for (schedule of Array.from(run_schedules)) {
						  $scope.schedules.push(schedule);
					  }
				  }
			  }
			  // Sort schedules by start date
			  return $scope.schedules.sort(function(a, b) {
				  if (a.start > b.start) { return -1; }
				  if (a.start < b.start) { return 1; }
				  return 0;
			  });
		  })
		  .catch(error => ngNotify.set('Erreur lors de la récupération des créneaux !', 'error'));

    const initFdtParams = function() {
        $scope.selected = {
            start:    moment(),
            end:      moment(),
            content:  ''
        };
        $scope.module_info =
            {module:   null};
        return $scope.schedule_info =
            {schedule: null};
    };

    initFdtParams();
    fetchSchedules();

    $scope.updateTimePicker = function() {
        $scope.min_date = $scope.schedule_info.schedule.start;
        return $scope.max_date = $scope.schedule_info.schedule.end;
    };

    $scope.declareLogs = function() {
        const contents = [
            $scope.content.goals.trim(),
            $scope.content.actions.trim(),
            $scope.content.results.trim(),
            $scope.content.difficulties.trim()
        ];
        if (($scope.module_info.module == null) || Array.from(contents).includes('')) {
            ngNotify.set('Veuillez remplir tous les champs obligatoires !', 'error');
            return;
        }
        $scope.form_loading     = true;
        $scope.errors           = [];
        $scope.selected.start   = $scope.selected.start.format('YYYY-MM-D H:mm');
        $scope.selected.end     = $scope.selected.end.format('YYYY-MM-D H:mm');
        $scope.selected.content = `Objectifs :\n${$scope.content.goals}\nActions :\n \
${$scope.content.actions}\nRésultats :\n${$scope.content.results} \
\nDifficultés rencontrées :\n ${$scope.content.difficulties}`;

        Log
        .declareLogs({
            module:      $scope.module_info.module.id,
            declaration: $scope.selected,
            sosJawa:     $scope.sos_jawa.value}).$promise
        .then(function() {
            ngNotify.set('Vos temps de log ont bien été enregistrés', 'success');
          return initFdtParams();
		})
		.catch(function(api_error) {
          let error_msg = "\nUn problème est survenu lors de l\'enregistrement de vos logs veuillez réessayer ultérieurement\n";
          for (let message in api_error.data) {
            const matches = message.match(/\[(.+)\]/);
            if (matches != null) {
			  FormElementService.addError(matches[1], api_error.data[message].join(', '));
			}
            error_msg = 'veuillez remplir tous les champs requis avant de valider le formulaire.';
          }
          $scope.errors = FormElementService.getErrors();
          ngNotify.set(error_msg, 'error');
		})
		.finally(() => $scope.form_loading = false);
    };
});
